export const LANGUEGES = [
    'ht',
    'gb',
    'is',
    'ml',
    'gu',
    'ko',
    'rw',
    'it',
    'ms',
    'si',
    'ar',
    'id',
    'cn',
    'es',
    'sq',
    'br',
    'th',
    'rn',
    'et',
    'af',
    'cv',
    'ka',
    'uk',
    'dv',
    'el',
    'ca',
    'fo',
    'ku',
    'be',
    'az',
    'mi',
    'ss',
    'hu',
    'mr',
    'cy',
    'ta',
    'te',
    'sv',
    'da',
    'pt',
    'bs',
    'se',
    'bg',
    'ro',
    'de',
    'bm',
    'km',
    'hr',
    'am',
    'sw',
    'mn',
    'tr',
    'tg',
    'bo',
    'ja',
    'ky',
    'eu',
    'nl',
    'ga',
    'vi',
    'lo',
    'cs',
    'gd',
    'lv',
    'ne',
    'ur',
    'sk',
    'fy',
    'he',
    'ru',
    'my',
    'nb',
    'fi',
    'lb',
    'mt',
    'kn',
    'en',
    'bn',
    'sl',
    'gl',
    'me',
    'jv',
    'mk',
    'kk',
    'tk',
    'nn',
    'eo',
    'bi',
    'lt',
    'fa',
    'sd',
    'sr',
    'hi',
    'uz',
    'fr',
    'pl'
];
